import Rellax from 'rellax';

(() => {
	// Added onload event because of strange bug with picture not showing on page load, and only on resize of browser.
	window.onload = () => {
		// Checking if rellax element exist on current page
		const parallaxElements = [...document.querySelectorAll('.rellax')];
		if(parallaxElements.length > 0) {
			new Rellax('.rellax', {
				speed: -4,
				center: true
			});
		}
	};
})();
